import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import {api} from '../../../api/api-dictionnary';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {HydraService} from '../../../core/services/hydra.service';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle
} from '@angular/material/dialog';
import {ExpertSaisie} from '../../../class/api/ExpertSaisie';
import {MotCle} from '../../../class/api/MotCle';
import {Personne, PersonneInterface} from '../../../class/api/Personne';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {Subscription} from 'rxjs';

import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { ControlsMessagesComponent } from '../controls-messages/controls-messages.component';
import { MotclesComponent } from '../motcles/motcles.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-expert',
    template: `
        <h4 mat-dialog-title>{{ titre }}</h4>
        <br />
        @if (expert !== null) {
          <mat-dialog-content>
            <div class="row">
              @if (configuration.civilite.display) {
                <div class="col-2">
                  <fieldset class="form-group  {{(!ctrlCivilite.valid && ctrlCivilite.errors !== null) ? 'form-error' : ''}}">
                    <label for="civilite">{{'general.personne.civilite' | translate}} :
                      @if (configuration.civilite.obligatoire) {
                        <span
                          class="star"
                          >*</span
                          >
                          }</label
                          >
                          <mat-select
                            [(ngModel)]="expert.personne['civilite']"
                            id="civilite"
                            name="civilite"
                            class="form-control"
                            #ctrlCivilite="ngModel"
                            [required]="configuration.civilite.obligatoire"
                            [compareWith]="compareByLetter"
                            >
                            <mat-option value="m">{{'general.monsieur'|translate}}</mat-option>
                            <mat-option  value="f">{{'general.madame'|translate}}</mat-option>
                          </mat-select>
                          <app-controls-messages [control]="ctrlCivilite"></app-controls-messages>
                        </fieldset>
                      </div>
                    }
                    @if (configuration.nom.display) {
                      <div class="col-3">
                        <fieldset class="form-group {{(!ctrlNom.valid && ctrlNom.errors !== null) ? 'form-error' : ''}}">
                          <label for="Nom"
                            >{{'general.personne.nom'|translate}} :
                            @if (configuration.nom.obligatoire) {
                              <span
                                class="star"
                                >*</span
                                >
                                }</label
                                >
                                <input
                                  [(ngModel)]="expert.personne['nom']"
                                  type="text"
                                  class="form-control"
                                  id="Nom"
                                  name="Nom"
                                  #ctrlNom="ngModel"
                                  [required]="configuration.nom.obligatoire"
                                  />
                                  <app-controls-messages [control]="ctrlNom"></app-controls-messages>
                                </fieldset>
                              </div>
                            }
                            @if (configuration.prenom.display) {
                              <div class="col-3">
                                <fieldset class="form-group {{(!ctrlPrenom.valid && ctrlPrenom.errors !== null) ? 'form-error' : ''}}">
                                  <label for="Prénom"
                                    >{{'general.prenom'|translate}} :
                                    @if (configuration.prenom.obligatoire) {
                                      <span
                                        class="star"
                                        >*</span
                                        >
                                      }</label
                                      >
                                      <input
                                        [(ngModel)]="expert.personne['prenom']"
                                        type="text"
                                        class="form-control"
                                        id="Prénom"
                                        name="Prénom"
                                        #ctrlPrenom="ngModel"
                                        [required]="configuration.prenom.obligatoire"
                                        />
                                        <app-controls-messages [control]="ctrlPrenom"></app-controls-messages>
                                      </fieldset>
                                    </div>
                                  }
                                  @if (configuration.email.display) {
                                    <div class="col-4">
                                      <fieldset class="form-group {{(!prmEmail.valid && prmEmail.errors !== null) ? 'form-error' : ''}}">
                                        <label for="Email"
                                          >{{'general.email'|translate}} :
                                          @if (configuration.email.obligatoire) {
                                            <span
                                              class="star"
                                              >*</span
                                              >
                                            }</label
                                            >
                                            <input
                                              [(ngModel)]="expert.email"
                                              type="text"
                                              class="form-control"
                                              id="Email"
                                              name="Email"
                                              email #prmEmail="ngModel"
                                              />
                                              <app-controls-messages [control]="prmEmail"></app-controls-messages>
                                            </fieldset>
                                          </div>
                                        }
                                      </div>
                                      @if (configuration.expertises.display) {
                                        <div class="row">
                                          <div class="col">
                                            <app-motcles
                                              (add)="add($event)" (remove)="remove($event)"
                                              [motsCles]="expert.expertises"
                                              [type]="'expertises'"
                                              #motCles
                                            ></app-motcles>
                                          </div>
                                        </div>
                                      }
                                      <div class="row mt-1">
                                        <div class="col-6">
                                          <fieldset class="form-group">
                                            <label for="laboratoire"
                                              >{{'general.laboratoireLabel'|translate}} :
                                              @if (configuration.laboratoire.obligatoire) {
                                                <span
                                                  class="star"
                                                  >*</span
                                                  >
                                                }</label
                                                >
                                                <input
                                                  [(ngModel)]="expert.laboratoire"
                                                  type="text"
                                                  class="form-control"
                                                  id="laboratoire"
                                                  name="laboratoire"
                                                  />
                                                </fieldset>
                                              </div>
                                              @if (configuration.ville.display) {
                                                <div class="col-3">
                                                  <fieldset class="form-group {{(!ctrlVille.valid && ctrlVille.errors !== null) ? 'form-error' : ''}}">
                                                    <label for="Ville"
                                                      >{{'general.ville'|translate}} :
                                                      @if (configuration.ville.obligatoire) {
                                                        <span
                                                          class="star"
                                                          >*</span
                                                          >
                                                        }</label
                                                        >
                                                        <input
                                                          [(ngModel)]="expert.ville"
                                                          type="text"
                                                          [required]="configuration.ville.obligatoire"
                                                          class="form-control"
                                                          id="Ville"
                                                          name="Ville"
                                                          #ctrlVille="ngModel"
                                                          />
                                                          <app-controls-messages [control]="ctrlVille"></app-controls-messages>
                                                        </fieldset>
                                                      </div>
                                                    }
                                                    @if (configuration.pays.display) {
                                                      <div class="col-3">
                                                        <fieldset class="form-group {{(!ctrlPays.valid && ctrlPays.errors !== null) ? 'form-error' : ''}}">
                                                          <label for="Pays"
                                                            >{{'general.pays'|translate}} :
                                                            @if (configuration.pays.obligatoire) {
                                                              <span
                                                                class="star"
                                                                >*</span
                                                                >
                                                              }</label
                                                              >
                                                              <mat-select
                                                                [(ngModel)]="expert.pays"
                                                                class="form-control"
                                                                name="pays"
                                                                id="pays"
                                                                [compareWith]="compareByCode"
                                                                [required]="configuration.pays.obligatoire"
                                                                #ctrlPays="ngModel"
                                                                >
                                                                @for (countrie of countries; track countrie) {
                                                                  <mat-option
                                                                    [value]="countrie"
                                                                    >
                                                                    {{ countrie.label }}
                                                                  </mat-option>
                                                                }
                                                              </mat-select>
                                                              <app-controls-messages [control]="ctrlPays"></app-controls-messages>
                                                            </fieldset>
                                                          </div>
                                                        }
                                                      </div>
                                                      @if (configuration.laboratoire.display) {
                                                        <div class="row">
                                                        </div>
                                                      }
                                                    </mat-dialog-content>
                                                  }
                                                  <mat-dialog-actions>
                                                    <button mat-button [mat-dialog-close]="false">{{'general.annuler'|translate}}</button>
                                                    <button
                                                      mat-raised-button
                                                      [disabled]="!formIsValid()"
                                                      (click)="save()"
                                                      color="primary"
                                                      >
                                                      {{ titre }}
                                                    </button>
                                                  </mat-dialog-actions>
        `,
    imports: [CdkScrollable, MatDialogContent, MatSelect, FormsModule, MatOption, ControlsMessagesComponent, MotclesComponent, MatDialogActions, MatButton, MatDialogClose, TranslateModule, MatDialogTitle]
})
export class ModalExpertComponent implements OnInit {
    translate = inject(TranslateService);
    hydraService = inject(HydraService);
    dialogRef = inject<MatDialogRef<ModalExpertComponent>>(MatDialogRef);
    private changeDetector = inject(ChangeDetectorRef);
    data = inject(MAT_DIALOG_DATA);

    public titre = 'Ajouter un expert';
    public countries = [];
    public configuration = {
        question: { display: true, value: '' },
        civilite: { display: true, obligatoire: true },
        nom: { display: true, obligatoire: true },
        prenom: { display: true, obligatoire: true },
        email: { display: true, obligatoire: false },
        expertises: { display: false, obligatoire: false },
        laboratoire: { display: false, obligatoire: false },
        ville: { display: true, obligatoire: true },
        pays: { display: true, obligatoire: true },
        min: 0,
        max: 3,
    };
    public expert: ExpertSaisie = new ExpertSaisie({
        personne: new Personne(),
        expertises: []
    });

    public langueMotCle = '["FR","EN"]';
    public subscriptions: Subscription[] = [];
    private messageAjoutExpert = 'general.ajouterExpert';
    private messageModifExpert = 'front.nommerExpert.modifierExpert';

    constructor() {
        this.hydraService
            .getList(api.countries, true)
            .subscribe((res: HydraCollection) => {
                this.countries = res.getMember();
                this.configuration = this.data.configuration;
                this.expert = new ExpertSaisie(this.data.expert);
                this.expert.personne = new Personne(this.expert.personne as PersonneInterface);
            });

        this.getTranslations();
        if (this.data.expert.personne.id) {
            this.titre = this.messageModifExpert;
        }
        else {
            this.titre = this.messageAjoutExpert;
        }
    }

    public getTranslations(){
        this.subscriptions.push( this.translate.get(this.messageAjoutExpert).subscribe(res => this.messageAjoutExpert = res) );
        this.subscriptions.push( this.translate.get(this.messageModifExpert).subscribe(res => this.messageModifExpert = res) );
    }

    public compareByid(itemOne, itemTwo) {
        return itemOne && itemTwo && itemOne.id == itemTwo.id;
    }

    public formIsValid() {

        const cf = this.configuration;
        // Civilite
        if (cf.civilite.display && cf.civilite.obligatoire) {
            if (
                this.expert.personne['civilite'] == null ||
                !this.expert.personne['civilite'].length
            ) {
                return false;
            }
        }

        // Nom
        if (cf.nom.display && cf.nom.obligatoire) {
            if (
                this.expert.personne['nom'] == null ||
                !this.expert.personne['nom'].length
            ) {
                return false;
            }
        }

        // Prénom
        if (cf.prenom.display && cf.prenom.obligatoire) {
            if (
                this.expert.personne['prenom'] == null ||
                !this.expert.personne['prenom'].length
            ) {
                return false;
            }
        }
        // Email
        if (cf.email.display && cf.email.obligatoire) {
            if (this.expert.email == null || !this.expert.email.length) {
                return false;
            }
        }

        if(cf.expertises.display && cf.expertises.obligatoire && this.expert.expertises.length < 3) {
            return false;
        }

        // Laboratoire
        if (cf.laboratoire.display && cf.laboratoire.obligatoire) {
            if (
                this.expert.laboratoire == null ||
                !this.expert.laboratoire.length
            ) {
                return false;
            }
        }

        // Ville
        if (cf.ville.display && cf.ville.obligatoire) {
            if (this.expert.ville == null || !this.expert.ville.length) {
                return false;
            }
        }

        // Pays
        if (cf.pays.display && cf.pays.obligatoire) {
            if (this.expert.pays == null || this.expert.pays == '') {
                return false;
            }
        }

        return true;
    }

    public compareByLetter(itemOne, itemTwo) {
        return itemOne == itemTwo;
    }

    public compareByCode(itemOne, itemTwo) {
        return itemOne && itemTwo && itemOne.code == itemTwo.code;
    }

    public save() {
        this.dialogRef.close(this.expert);
    }

    public add(item) {
        this.subscriptions.push(
            this.hydraService
                .save(api.motCles, item)
                .subscribe((res: MotCle) => {
                    if(item.id) {
                        const index = this.expert.expertises.findIndex(element => element.id === item.id);
                        this.expert.expertises[index] = res;
                    } else {
                        this.expert.expertises[this.expert.expertises.length - 1] = res;
                    }
                    this.expert.expertises = [...this.expert.expertises];
                })
        );
    }
    public remove(item) {
        this.expert.expertises = [...this.expert.expertises];
    }

    ngOnInit() {
        this.changeDetector.detectChanges();
    }
}
